export interface BaseCursorPagingArgs {
  before?: string
  after?: string
  first?: number
  last?: number
}

export const getBaseCursorPagingArgs = ({
  before,
  after,
  pageSize,
  isPosSeq,
}: {
  before?: string
  after?: string
  pageSize: number
  isPosSeq?: boolean
}) => {
  const args: BaseCursorPagingArgs = {
    after,
    before,
  }

  if (isPosSeq) {
    if (before) {
      args.last = pageSize
    } else {
      args.first = pageSize
    }
  } else {
    if (after) {
      args.first = pageSize
    } else {
      args.last = pageSize
    }
  }

  return args
}
